export default __webpack_public_path__ + "static/media/coeur.89468daf.svg";